exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swiper-container {\n  width: 100%;\n  height: 70vw; }\n\n.swiper-pagination-bullet {\n  background: #999;\n  opacity: 0.5; }\n\n.swiper-pagination-bullet-active {\n  opacity: 1; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/js/common/menu/menu-item-expanded/photo-swiper/photo-swiper.scss
 ** module id = 784
 ** module chunks = 1 16 173
 **/